import React from "react";
import { Link } from "react-router-dom";
import { TID } from "@/lib/testIds";

export default function NotFoundPage() {
  return (
    <div data-testid={TID.notFoundPage} className="container-narrow py-24 text-center">
      <div className="font-serif font-black text-8xl sm:text-9xl text-petroleum leading-none">404</div>
      <h1 className="mt-4 font-serif text-3xl sm:text-4xl font-bold text-blueblack">Página no encontrada</h1>
      <p className="mt-3 text-textgray max-w-md mx-auto">
        La nota que buscás no existe o fue movida. Podés volver a la portada o probar el buscador.
      </p>
      <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
        <Link
          to="/"
          data-testid={TID.goHomeLink}
          className="inline-flex items-center gap-2 bg-nightblue hover:bg-blueblack text-white h-11 px-6 font-semibold uppercase text-xs tracking-widest transition-colors"
        >
          Ir a la portada
        </Link>
        <Link
          to="/buscar"
          className="inline-flex items-center gap-2 border border-softblue text-nightblue hover:bg-lightgray h-11 px-6 font-semibold uppercase text-xs tracking-widest transition-colors"
        >
          Buscar noticias
        </Link>
      </div>
    </div>
  );
}
